import React from "react";
import PropTypes from "prop-types";
import IconButtonWithTooltip from "./IconButtonWithTooltip";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import OpenInFullOutlinedIcon from "@mui/icons-material/OpenInFullOutlined";
import CloseFullscreenOutlinedIcon from "@mui/icons-material/CloseFullscreenOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

const RightButtonGroup = ({
  toggleFilterModal,
  isExpanded,
  setIsExpanded,
  onExport,
}) => {
  return (
    <div className="flex items-center space-x-2">
      <IconButtonWithTooltip tooltip="Export" onClick={onExport}>
        <FileDownloadOutlinedIcon />
      </IconButtonWithTooltip>

      <IconButtonWithTooltip tooltip="Filter" onClick={toggleFilterModal}>
        <FilterAltOutlinedIcon />
      </IconButtonWithTooltip>

      <IconButtonWithTooltip
        tooltip={isExpanded ? "Shrink" : "Expand"}
        onClick={setIsExpanded}
      >
        {isExpanded ? (
          <CloseFullscreenOutlinedIcon className="text-sss-info" />
        ) : (
          <OpenInFullOutlinedIcon />
        )}
      </IconButtonWithTooltip>
    </div>
  );
};

RightButtonGroup.propTypes = {
  toggleFilterModal: PropTypes.func,
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  onExport: PropTypes.func,
};

export default RightButtonGroup;
